import { FormGroup } from '@angular/forms'
import { Component, OnInit, Input } from '@angular/core'
import { ContainerElement, UnknownParams } from '@app/form-builder/interfaces/form.interface'

@Component({
    selector: 'table-container',
    templateUrl: './table.component.html',
    host: {
        '[style.display]': 'attributes.fit ? "block" : ""',
        '[style.overflow]': 'attributes.fit ? "auto" : ""'
    }
})
export class SectionTableComponent implements OnInit {

    @Input() data: ContainerElement
    @Input() form: FormGroup

    attributes: UnknownParams = {}

    constructor() {}

    ngOnInit() {
        for (var i in this.data.attributes) {
            const attribute = this.data.attributes[i]
            this.attributes[attribute.name] = attribute.value
        }
    }

    getColspan(item) {
        if(!item.attributes) return 1

        const index = item.attributes.findIndex(attr => attr.name === 'colspan');
        if (index !== -1) return item.attributes[index].value;
        else return 1
    }
}